import React from "react";
import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";
import LabelWithInput from "@components/input/LabelWithInput";
import { useFormContext } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { getAudienceLabel } from "@utils/productClassification";

const GenderSelector = () => {
  const { setValue, watch } = useFormContext();
  const { getAudienceCategoryList } = useApiRequest();
  const selectedIds: number[] = watch("audience_category_ids") || [];
  const { data: options = [] } = useQuery({
    queryKey: ["audienceCategoryList"],
    queryFn: getAudienceCategoryList,
  });

  const toggle = (option: any) => {
    const id = Number(option.id);
    const next = selectedIds.includes(id)
      ? selectedIds.filter((value) => value !== id)
      : [...selectedIds, id];
    setValue("audience_category_ids", next, { shouldValidate: true });
    const first = options.find((item: any) => Number(item.id) === Number(next[0]));
    setValue("gender", first?.code?.toLowerCase() || "", { shouldValidate: true });
  };

  return (
    <div>
      <LabelWithInput label="앱 대분류" required />
      <Container>
        {options.map((option: any) => (
          <BasicButton
            key={option.id}
            title={getAudienceLabel(option)}
            fit
            gray
            active={selectedIds.includes(Number(option.id))}
            width="100%"
            fontSize="1.2rem"
            transparent
            padding="1rem"
            borderColor="#ccc"
            onClick={() => toggle(option)}
          />
        ))}
      </Container>
    </div>
  );
};

export default GenderSelector;

const Container = styled.div({
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem",
  justifyContent: "flex-start",
  alignItems: "flex-start",
});
